import React from 'react';

const defaultValue = {};

export const TemplateParamsContext = React.createContext(defaultValue);

export default TemplateParamsContext;
